/**
 * 手工汇款
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { Modal, Radio, Form, Input, message } from 'antd';

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
};
const { TextArea } = Input;
class NoLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
            title: this.props.title,
            visible: this.props.visible,
        };
    }
    formRef = React.createRef();
    // 点击确认
    _handleOk = () => {
        const { reconciliationId } = this.props;
        this.formRef.current.validateFields().then(async (fieldsValue) => {
            http('/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.manualRemittance', { reconciliationId, ...fieldsValue }).then(res => {
                message.success("操作成功！")
                this.setState({ visible: false });
                this.props.closeModal(true);
            }).catch((res) => {
                message.error(res.message || '请求异常');
                this.setState({ visible: false });
                this.props.closeModal();
            });
        });

    };
    // 点击取消
    _handleCancel = () => {
        this.setState({ visible: false });
        this.props.closeModal();
    }
    render() {
        const { confirmLoading, title, visible } = this.state;
        return (
            <Modal
                title={title}
                width={600}
                centered
                visible={visible}
                confirmLoading={confirmLoading}
                keyboard
                destroyOnClose
                okText='确定'
                cancelText='取消'
                maskClosable={false}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
            >
                <Form
                    {...layout}
                    name="control-ref"
                    ref={this.formRef}
                    initialValues={{
                        verifyStatus: 'REMIT_SUCCESS'
                    }}
                >
                    <Form.Item
                        label="状态"
                        name="verifyStatus"
                        rules={[{ required: true, message: '请选择状态!' }]}
                    >
                        <Radio.Group>
                            <Radio value="REMIT_SUCCESS">汇款成功</Radio>
                            <Radio value="REMIT_FAIL">汇款失败</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item
                        label="备注"
                        name="remark"
                        rules={[{ required: true, message: '请输入备注!' }, { min: 2, message: '请输入至少2个字符' }]}
                    >
                        <TextArea rows={4} placeholder='请输入至少2个字符' />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
NoLogin.propTypes = {
    title: PropTypes.string,
    form: PropTypes.object,
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    data: PropTypes.object, // 弹框入参
    closeModal: PropTypes.func, // 关闭弹框的回调函数
    reconciliationId: PropTypes.string
};
export default connect(null, null)(NoLogin);
